import React, { useEffect, useState } from 'react'
import { Card } from 'primereact/card';
import AppSettings from './../services/AppSettings';
import { useLocation, useParams } from 'react-router-dom';





export const SelectOrganization = () => {

   
    const [iframeUrl, setIframeUrl] = useState('');
    const uid = window.sessionStorage.getItem('uid');
    const userid = window.sessionStorage.getItem('userid');
    const baseDomain = window.sessionStorage.getItem('baseDomain');

  
  
    const location = useLocation();
    const [queryParams, setQueryParams] = useState(null);
  
    useEffect(() => {
        const params = new URLSearchParams(location.search);
  
        setQueryParams(params.get("donationID") as any);
    }, [location]);
    const { donationID } = useParams();


      
      const donationid = donationID;
      console.log('donationid', donationid);



   
//  const url = `https://devreact.gearforneed.com/api/ws_fundmandonation.php?donationid=${donationid}&userid=${userid}`;
 const url = `${baseDomain}/ws_fundmandonation.php?donationid=${donationid}&userid=${userid}`;


console.log("url", url);





  return (
    <div className="admin-layout-container">
    <div className="row">
<div className="main-content">
            <div className="content-wrapper">
      <section className="content container-fluid">
        <div className="row">
          <iframe
        title="Example iframe"
        width="100%"
        height="840px"
        src={url}
        frameBorder="0"
        allowFullScreen
        style={{top:0, left:0, bottom:0,right:0, border:'none', margin:0, padding:0, overflow:'hidden'}}
      />
        </div>
      </section>
    </div>
</div>
</div>
    </div>
  )
}
export default SelectOrganization;